'use client'
import { useState, useEffect, useRef } from 'react';
import Image from 'next/image';
import { League } from '@/types/league';
import useClickOutside from '@/hooks/useClickOutside';
import { useTranslations } from 'next-intl';

interface SearchDropdownProps {
  options: League[];
  onSelect: (option: League) => void;
  label: string;
  clearSearch?: boolean
  placeholder?: string;
  sourceOfData?: string;
}

const SearchDropdown: React.FC<SearchDropdownProps> = ({ options, onSelect, placeholder, sourceOfData, clearSearch, label }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredOptions, setFilteredOptions] = useState(options);
  const [isLoading, setIsLoading] = useState(false);

  const dropdownSearchRef = useRef<HTMLDivElement>(null);

  const l = useTranslations('layout');

  useClickOutside(dropdownSearchRef, () => setIsOpen(false));

  useEffect(() => {
    if (clearSearch) {
      setSearchTerm('');
      setFilteredOptions([]);
    }
  }, [clearSearch]);

  useEffect(() => {
    
    if(searchTerm.length > 0 && sourceOfData === "static") {
      setIsOpen(true)
      setFilteredOptions(
        options.filter(option =>
          option.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (option.countryName && option.countryName.toLowerCase().includes(searchTerm.toLowerCase()))
        )
      );
    }
    if (sourceOfData === "dynamic") {
      
      if (searchTerm.length > 2) {
        fetchResults();
      } else if (searchTerm.length === 0) {
        setFilteredOptions([]);
      }
    }
  }, [searchTerm]);

  const handleSelect = (option: League) => {
    onSelect(option);
    setSearchTerm("");
    setIsOpen(false);
  };

  const fetchResults = async () => {
    setIsLoading(true);
    setIsOpen(true)
    
    const response = await fetch(`/api/search/teams-leagues?query=${encodeURIComponent(searchTerm)}`);
    const data = await response.json();

    setFilteredOptions(data);
    setIsLoading(false);
  };

  return (
    <div className='form-group' ref={dropdownSearchRef}>
      <label htmlFor="searchDropdown">{label}</label>
      <input
        id="searchDropdown"
        type="text"
        className="dropdown-search form-control w-100"
        placeholder={placeholder}
        value={searchTerm}
        onChange={(e) => setSearchTerm(e.target.value)}
      />
      {isOpen && (
          <ul className="dropdown position-absolute">
            {isLoading ? <li className="dropdown-item">{l('loading')}</li> : (
            origin === "static" ? 
              (filteredOptions?.map((option) => (
                <li
                  key={option.id}
                  className="dropdown-item"
                  onClick={() => handleSelect(option)}
                >
                  <Image src={option.logo} alt={option.name} width="20" height="20" loading="lazy" className="me-2" />
                  {option.countryName ? `${option.countryName} - ` : ""} 
                  {option.name}
                </li>
              )))
              :
              (filteredOptions?.map((option) => (
                <li
                  key={option.id + option.name}
                  className="dropdown-item"
                  onClick={() => handleSelect(option)}
                >
                  <Image src={option.logo} alt={option.name} width={20} height={20} loading="lazy" />
                  {option.countryName && <span> {option.countryName}</span>}
                  <span> - {option.name}</span>
                </li>
              ))))
            }
          </ul>
      )}
    </div>
  );
};

export default SearchDropdown;

